import {useParams} from "react-router";
import useAxiosConfigHeader from "../../../use/useAxiosConfigHeader";
import useSuggestionRepository from "../../../repository/assignment/useSuggestionRepository";
import {useEffect} from "react";
import isNull from "../../../mixin/isNull";
import Box from "@mui/material/Box";
import {CircularProgress} from "@mui/material";
import EmergencySuggestion from "./emergency/Suggestion";
import B2cSuggestion from "./b2c/Suggestion";
import B2csduSuggestion from "./b2csdu/Suggestion";
import InsuranceSuggestion from "./insurance/Suggestion";

export default function () {
    const {token} = useParams();
    const headerConfigured = useAxiosConfigHeader("assignment", token);
    const suggestionRepository = useSuggestionRepository();
    /** @type Suggestion */
    const suggestion = suggestionRepository.findOneByToken(token).select();

    useEffect(() => {
        if (!headerConfigured) return;

        suggestionRepository.findOneByToken(token).exec();
    }, [headerConfigured]);

    if (isNull(suggestion) || !headerConfigured) {
        return (
            <Box display="flex" justifyContent="center" mt={20}>
                <CircularProgress/>
            </Box>
        )
    }


    if (!isNull(suggestion.getOrderId())) return <EmergencySuggestion/>;

    if (!isNull(suggestion.getB2csduOrderId())) return <B2csduSuggestion/>;

    if (!isNull(suggestion.getInsuranceOrderId())) return <InsuranceSuggestion/>;

    return <B2cSuggestion/>;
}